import React from 'react';
import { Button, Popover, Select } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import VoiceTranscribeButton from '../../../../components/VoiceTranscribeButton';

interface EditorToolbarProps {
  /** Node dropdown options */
  nodeOptions: { label: string; value: string }[];
  /** Template dropdown options */
  templateOptions: { label: string; value: string; key: string; templateHtml: string }[];
  selectedNode: string | null;
  selectedTemplate: string | null;
  isSignedOff: boolean;
  onNodeChange: (val: string | null) => void;
  onTemplateSelect: (val: string | null, templateHtml?: string) => void;
  onTranscription?: (text: string, isPartial: boolean, replacePartial: boolean) => void;
}

const EditorToolbar: React.FC<EditorToolbarProps> = ({
  nodeOptions,
  templateOptions,
  selectedNode,
  selectedTemplate,
  isSignedOff,
  onNodeChange,
  onTemplateSelect,
  onTranscription,
}) => {
  const templatePopoverContent = isSignedOff ? (
    <div style={{ padding: '8px' }}>Templates cannot be used when editing a signed-off report</div>
  ) : (
    <div style={{ width: 300 }}>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>Node</div>
        <Select
          allowClear
          style={{ width: '100%' }}
          placeholder="Select Node"
          value={selectedNode}
          onChange={onNodeChange}
          onClear={() => onNodeChange(null)}
          options={nodeOptions}
        />
      </div>
      <div>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>Template</div>
        <Select
          allowClear
          style={{ width: '100%' }}
          placeholder="Select Template"
          value={selectedTemplate}
          onChange={(val) => {
            if (val) {
              const opt = templateOptions.find(t => t.value === val);
              onTemplateSelect(val, opt?.templateHtml);
            } else {
              onTemplateSelect(null);
            }
          }}
          onClear={() => onTemplateSelect(null)}
          options={templateOptions}
          disabled={!selectedNode}
        />
      </div>
    </div>
  );

  return (
    <>
      <Popover
        content={templatePopoverContent}
        title={isSignedOff ? 'Templates Disabled' : 'Select Template'}
        trigger="hover"
        placement="topLeft"
      >
        <Button className="use-template-btn" type="default" disabled={isSignedOff}>
          <FileTextOutlined />
          Use Template
        </Button>
      </Popover>

      {onTranscription && (
        <VoiceTranscribeButton
          onTranscriptionText={onTranscription}
          size="small"
          className="voice-transcribe-btn"
        />
      )}
    </>
  );
};

export default EditorToolbar;
